import { get, buildUrl } from "../shared/api"
import axios from "axios"

interface PaymentTokenData {
  token: string
  url: string
}

let paymentTokenData: PaymentTokenData | undefined

interface CardTokenRequestParams {
  card_number: string
  card_expire: string
  security_code: string
}

type CardTokenResponse = {
  status: "success"
  token: string
  token_expire_date: string
  req_card_number: string
  code: string
  message: string
} | {
  status: "failure"
  code: string
  message: string
}

export const getCardToken: (params: CardTokenRequestParams) => Promise<CardTokenResponse> = async (params) => {
  if (typeof paymentTokenData === 'undefined') {
    const paymentTokenResp = await get<PaymentTokenData>(buildUrl(`/api/v1/payment_token.json`))
    paymentTokenData = paymentTokenResp.data
  }

  const cardTokenResp = await axios.post<CardTokenResponse>(paymentTokenData.url, {
    ...params,
    token_api_key: paymentTokenData.token,
    lang: "ja"
  }, {
    validateStatus: status => status === 200 || status === 400
  })

  return cardTokenResp.data
}

if (process.env.NODE_ENV === 'development') {
  window["_getCardToken"] = getCardToken
}
